module.exports = __webpack_public_path__ + "img/ok.f216b893.svg";